import { render } from "./Certificate.vue?vue&type=template&id=313b360e&scoped=true"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"

import "./Certificate.vue?vue&type=style&index=0&id=313b360e&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313b360e"]])

export default __exports__